// API Base URL Configuration
const getApiBaseUrl = () => {
  // Use environment variable if available, otherwise use Vercel backend
  return process.env.REACT_APP_API_URL || 'https://naman-assessment-backend.vercel.app';
};

// Culture Dialogue API Service
export const cultureDialogueAPI = {
  // Submit invitation request
  submitRequest: async (data) => {
    try {
      const baseUrl = getApiBaseUrl();
      const url = `${baseUrl}/api/culture-dialogue/submit`;
      console.log('Submitting to:', url);
      
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      });

      // Try to parse response as JSON
      let result;
      try {
        const text = await response.text();
        if (text) {
          result = JSON.parse(text);
        } else {
          result = {};
        }
      } catch (parseError) {
        console.error('Failed to parse response as JSON:', parseError);
        throw new Error(`Server returned invalid response (Status: ${response.status}). Please check if the backend is configured correctly.`);
      }
      
      if (!response.ok) {
        throw new Error(result.message || result.error || `Server error: ${response.status} ${response.statusText}`);
      }
      
      return result;
    } catch (error) {
      console.error('Error submitting culture dialogue request:', error);
      
      // Handle network/CORS errors
      if (error.message.includes('Failed to fetch') || 
          error.message.includes('NetworkError') ||
          error.message.includes('Network request failed') ||
          error.name === 'TypeError') {
        throw new Error('Cannot connect to server. This could be due to CORS restrictions or the server being unavailable. Please check your internet connection and ensure the backend is accessible.');
      }
      
      // Re-throw if it's already a formatted error
      throw error;
    }
  },

  // Get all requests (admin)
  getAllRequests: async (page = 1, limit = 50, filters = {}) => {
    try {
      const baseUrl = getApiBaseUrl();
      const queryParams = new URLSearchParams({
        page: page.toString(),
        limit: limit.toString(),
        ...filters
      });
      
      const response = await fetch(`${baseUrl}/api/culture-dialogue/requests?${queryParams}`);
      const result = await response.json();
      
      if (!response.ok) {
        throw new Error(result.message || 'Failed to fetch requests');
      }
      
      return result;
    } catch (error) {
      console.error('Error fetching requests:', error);
      throw error;
    }
  },

  // Get statistics (admin)
  getStatistics: async () => {
    try {
      const baseUrl = getApiBaseUrl();
      const response = await fetch(`${baseUrl}/api/culture-dialogue/statistics`);
      const result = await response.json();
      
      if (!response.ok) {
        throw new Error(result.message || 'Failed to fetch statistics');
      }
      
      return result;
    } catch (error) {
      console.error('Error fetching statistics:', error);
      throw error;
    }
  },

  // Update request status (admin)
  updateStatus: async (id, status, notes = '') => {
    try {
      const baseUrl = getApiBaseUrl();
      const response = await fetch(`${baseUrl}/api/culture-dialogue/requests/${id}/status`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ status, notes }),
      });

      const result = await response.json();
      
      if (!response.ok) {
        throw new Error(result.message || 'Failed to update status');
      }
      
      return result;
    } catch (error) {
      console.error('Error updating status:', error);
      throw error;
    }
  }
};

export { getApiBaseUrl };

